module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "regraDiasPendentesModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "regraDiasPendentesModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Ciente",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "regraDiasPendentesModalLabel"
    }
  }, [_vm._v("\n            Dias de Férias Pendentes\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', [_vm._v("Você tem dias pendentes de férias!")]), _vm._v(" "), _c('p', [_vm._v("\n                Conforme item 4 da O.S. nº 02/2014 GP, os dias restantes de\n                férias deverão ser gozados de uma única vez, antes do gozo das\n                próximas férias.\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                Você poderá fazer o agendamento na\n                tela seguinte, mas deverá agendar em paralelo os seus dias restantes\n                através de memorando enviando e-mail para\n                o endereço ferias@santos.sp.gov.br\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "alerta"
  }, [_vm._v("\n                ATENÇÃO, o não cumprimento do disposto acima implicará na perda do direito\n                ao gozo dos dias restantes.\n              ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57c4b24a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ferias/regra-dias-pendentes-modal.vue
// module id = gI/F
// module chunks = 5